import apiKindsSportBySchool from '@/api/kinds-sports-by-school'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getKindsSportBySchoolStart:
    '[kinds sports by school] Get kinds sports by school start',
  getKindsSportBySchoolSuccess:
    '[kinds sports by school] Get kinds sports by school success',
  getKindsSportBySchoolFailure:
    '[kinds sports by school] Get kinds sports by school failure',
}

export const actionTypes = {
  getKindsSportBySchool: '[kinds sports by school] Get kinds sports by school',
}

const mutations = {
  [mutationTypes.getKindsSportBySchoolStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getKindsSportBySchoolSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getKindsSportBySchoolFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getKindsSportBySchool](context, data) {
    context.commit(mutationTypes.getKindsSportBySchoolStart)
    return new Promise((resolve) => {
      apiKindsSportBySchool
        .getKindsSportAll(data)
        .then((response) => {
          context.commit(
            mutationTypes.getKindsSportBySchoolSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getKindsSportBySchoolFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
